import { destroy } from "jiffy-api";
import EventClass from "common/utils/ui/event-class";
import digitalAssetsAssetsUploadComponent from "./digital-assets-assets-upload-component";

export class DigitalAssetsAssetsUploadedFiles extends EventClass {
  #cloneFileSelector;

  #fileListSelector;

  #filesComponent = digitalAssetsAssetsUploadComponent();

  constructor(options) {
    super({
      eventSelector: options.deleteFormSelector,
      event: "submit"
    });

    this.#cloneFileSelector = options.fileTemplateSelector;
    this.#fileListSelector = options.fileListSelector;
  }

  get $fileList() {
    return document.querySelector(this.#fileListSelector);
  }

  get $cloneFile() {
    const $clone = document.querySelector(this.#cloneFileSelector).cloneNode(true);
    $clone.classList.remove("hidden");
    $clone.removeAttribute("id");
    return $clone;
  }

  /**
   * @method event
   * @param {Event} event
   * @returns {Promise<void>}
   * @override EventClass.event
   * @description This method is called when the file remove form is submitted.
   */
  async event(event) {
    event.preventDefault();

    const isConfirmed = window.confirm("Are you sure you want to delete this file?"); // eslint-disable-line no-alert

    if (isConfirmed) {
      const $form = event.target;

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": undefined
        },
        raw: true
      };

      const response = await destroy($form.getAttribute("action"))(null, config);

      $form.remove();

      if (response.count === 0) {
        this.#filesComponent.hideFilesList();
      }
    }
  }

  addFile(file) {
    const $form = this.$cloneFile;
    const $downloadLink = $form.querySelector(".js-digital-assets-file-download");
    const $name = $form.querySelector("[data-name]");
    const $size = $form.querySelector("[data-size]");

    $name.textContent = file.filename;
    $size.textContent = file.size;
    $form.setAttribute("action", `${$form.getAttribute("action")}${file.id}`);
    if ($downloadLink) {
      $downloadLink.setAttribute("href", `${$downloadLink.getAttribute("href")}${file.id}`);
    }

    this.$fileList.appendChild($form);
  }
}

export default () =>
  new DigitalAssetsAssetsUploadedFiles({
    fileListSelector: ".js-digital-assets-files-list",
    deleteFormSelector: ".js-digital-assets-file-delete",
    fileTemplateSelector: "#js-digital-assets-file-template"
  });
